import { render, staticRenderFns } from "./SpecialPriceAdjDetails.vue?vue&type=template&id=fd135012&scoped=true&"
import script from "./SpecialPriceAdjDetails.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceAdjDetails.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=fd135012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd135012",
  null
  
)

export default component.exports